import { WORKSHOP_SPECIALTIES, WORKSHOP_SEGMENT_KEYS, WORKSHOP_SEGMENT_LABELS } from '@mustauto/types';
import { cn } from './cn';

interface SpecialtyPickerProps {
  /** Chaves selecionadas. Chave desconhecida é ignorada na renderização. */
  value: string[];
  onToggle: (key: string) => void;
  disabled?: boolean;
}

/**
 * Seleção de especialidades da oficina, agrupada por segmento.
 *
 * Nasce no kit porque já tinha duas cópias idênticas no web-admin (Settings e
 * o passo de onboarding) — a classe-raiz de drift que a Regra 11 nomeia.
 *
 * O agrupamento não é enfeite: a lista passou de 14 para 20 chaves em 2026-09,
 * quando entraram as de funilaria e estética. Numa parede achatada de 20 chips,
 * o detailer não acha "Vitrificação" — e o objetivo da mudança era exatamente
 * que ele conseguisse se declarar.
 */
export function SpecialtyPicker({ value, onToggle, disabled = false }: SpecialtyPickerProps) {
  return (
    <div className="flex flex-col gap-4">
      {WORKSHOP_SEGMENT_KEYS.map((segment) => {
        const specialties = WORKSHOP_SPECIALTIES.filter((s) => s.segment === segment);
        if (specialties.length === 0) return null;

        return (
          <div key={segment} className="flex flex-col gap-2">
            <span className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
              {WORKSHOP_SEGMENT_LABELS[segment]}
            </span>
            <div className="flex flex-wrap gap-2">
              {specialties.map((spec) => {
                const selected = value.includes(spec.key);
                return (
                  <button
                    key={spec.key}
                    type="button"
                    disabled={disabled}
                    aria-pressed={selected}
                    onClick={() => onToggle(spec.key)}
                    className={cn(
                      'rounded-full px-3 py-1 text-xs font-medium transition-colors',
                      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1',
                      'disabled:cursor-not-allowed disabled:opacity-50',
                      selected
                        ? 'bg-primary text-primary-foreground'
                        : 'border border-input bg-background text-muted-foreground hover:border-primary/50',
                    )}
                  >
                    {spec.label}
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
